import { AuthenthicatedUserInfo, LoanStatus, LoanStatusId, LoanType, LoanTypeId } from '../interfaces';
import { USER_KEY } from './constants';

export const handleApiError = (error: any): string => {
  return error.response ? error.response.data.message : 'Error processing request. Please try again later';
};

export const getParameterByName = (name: string, url = window.location.href) => {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

/**
 * Returns authorization header
 * @returns {}
 */
export const setAuthHeader = () => {
  const user: AuthenthicatedUserInfo = JSON.parse(localStorage.getItem(USER_KEY)!);
  const token = user['token'];
  return { Authorization: `Bearer ${token}` };
};

export const getLoanTypeIdFromLoanTypeName = (loanType: string) => {
  switch (loanType) {
    case LoanType.MORTGAGE:
      return LoanTypeId.MORTGAGE;
    case LoanType.EQUITY_FINANCE:
      return LoanTypeId.EQUITY_FINANCE;
    case LoanType.RENT:
      return LoanTypeId.RENT;
    case LoanType.PAYDAY:
      return LoanTypeId.PAYDAY;
    default:
      return LoanTypeId.PAYDAY;
  }
};

export const getLoanTypeNameFromLoanTypeId = (loanType: number) => {
  switch (loanType) {
    case LoanTypeId.MORTGAGE:
      return LoanType.MORTGAGE;
    case LoanTypeId.EQUITY_FINANCE:
      return LoanType.EQUITY_FINANCE;
    case LoanTypeId.RENT:
      return LoanType.RENT;
    case LoanTypeId.PAYDAY:
      return LoanType.PAYDAY;
    default:
      return LoanType.PAYDAY;
  }
};

export const getLoanStatusIdFromLoanStatusName = (loanStatus: string) => {
  switch (loanStatus) {
    case LoanStatus.OPEN:
      return LoanStatusId.OPEN;
    case LoanStatus.UNDERWRITING:
      return LoanStatusId.UNDERWRITING;
    case LoanStatus.ONGOING:
      return LoanStatusId.ONGOING;
    case LoanStatus.CLOSED:
      return LoanStatusId.CLOSED;
    default:
      return LoanStatusId.OPEN;
  }
};

export const getLoanStatusNameFromLoanStatusId = (loanStatus: number) => {
  switch (loanStatus) {
    case LoanStatusId.OPEN:
      return LoanStatus.OPEN;
    case LoanStatusId.UNDERWRITING:
      return LoanStatus.UNDERWRITING;
    case LoanStatusId.ONGOING:
      return LoanStatus.ONGOING;
    case LoanStatusId.CLOSED:
      return LoanStatus.CLOSED;
    default:
      return LoanStatus.OPEN;
  }
};

export const dateFormat = (dateString: string) => {
  return (
    new Date(dateString).toLocaleDateString('en-gb', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    }) +
    ', ' +
    new Date(dateString).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  );
};

  export const calculateLoan = (principal: number, interest: number, repayment: number) => {
    if (!principal || !interest || !repayment) return null

    const interestPaid = (principal * interest * (repayment / 12)) / 100;
    const totalAmountPaid = principal + interestPaid;
    const monthlyPayment = Math.ceil(totalAmountPaid / repayment);

    return {interestPaid, totalAmountPaid, monthlyPayment}
  };
